import React from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

const variants = {
  ice: 'bg-[#EEF3F8]',
  even: 'bg-[#D8E8F0]',
  odd: 'bg-[#E8EEF3]',
  dark: 'bg-[#2E3A46] text-[#EEF3F8]',
  'dark-frame': 'bg-[#354551] text-[#EEF3F8]',
  white: 'bg-white',
};

const Section = ({ id, variant = 'ice', className = '', children, noPadding = false, bgColor, bgImage, bgOpacity, headingColor, bodyColor, headingSize }) => {
  const hasBgImage = bgImage && bgImage.startsWith('/');
  const isDark = variant === 'dark' || variant === 'dark-frame';

  const style = {};
  if (bgColor) style.backgroundColor = bgColor;

  const textStyle = {};
  if (headingColor) textStyle['--section-heading-color'] = headingColor;
  if (bodyColor) textStyle['--section-body-color'] = bodyColor;
  if (headingSize) textStyle['--section-heading-size'] = `${headingSize}px`;

  return (
    <section
      id={id}
      className={`${!bgColor ? (variants[variant] || variants.ice) : ''} ${isDark && !bgColor ? '' : ''} ${noPadding ? '' : 'py-14 md:py-20'} ${className} relative overflow-hidden`}
      style={style}
    >
      {/* Background image overlay */}
      {hasBgImage && (
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url(${BACKEND_URL}${bgImage})`,
            opacity: bgOpacity != null ? (parseInt(bgOpacity) / 100) : 0.3,
          }}
        />
      )}
      {/* Dark text overlay for readability on bg images */}
      {isDark && <div className="absolute inset-0" style={{ backgroundColor: bgColor || (variant === 'dark-frame' ? '#354551' : '#2E3A46'), opacity: hasBgImage ? 0.85 : 1 }} />}

      <div className={`${noPadding ? '' : 'mx-auto w-full max-w-7xl px-4 sm:px-6'} relative z-10 ${isDark ? 'text-[#EEF3F8]' : ''}`}
        style={textStyle}>
        {children}
      </div>
    </section>
  );
};

export const SectionTitle = ({ children, subtitle, light = false, className = '' }) => (
  <div className={`text-center mb-10 md:mb-14 ${className}`}>
    <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl mb-4"
      style={{ color: 'var(--section-heading-color, ' + (light ? '#EEF3F8' : '#2E3A46') + ')', fontSize: 'var(--section-heading-size, 2.25rem)' }}>
      {children}
    </h2>
    {subtitle && (
      <p className="text-base md:text-lg max-w-2xl mx-auto"
        style={{ color: 'var(--section-body-color, ' + (light ? '#C5D0DA' : '#7A9BB5') + ')' }}>
        {subtitle}
      </p>
    )}
  </div>
);

export default Section;
